import { User } from "src/models";

export type UserSession = {
    loading: boolean;
    loggedIn: boolean;
    user?: User;
    fetching: boolean;
    pwaSeen: boolean;
    packageBannerReshowDate?: Date;
};


export const UserSessionInitialState: UserSession = {
    loading: false,
    loggedIn: false,
    user: undefined,
    fetching: true,
    pwaSeen: false,
};